import { render, staticRenderFns } from "./ShorexIntroList.vue?vue&type=template&id=6ab7fcea&scoped=true"
import script from "./ShorexIntroList.vue?vue&type=script&lang=js"
export * from "./ShorexIntroList.vue?vue&type=script&lang=js"
import style0 from "./ShorexIntroList.vue?vue&type=style&index=0&id=6ab7fcea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7fcea",
  null
  
)

export default component.exports